// extracted by mini-css-extract-plugin
export default {"ArticleLayout":"ArticleLayout_ArticleLayout__bA8+4","content":"ArticleLayout_content__8mdJB"};